(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/actions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/actions.js');
"use strict";


const SET_BRANDING = svs.tickets_giftshop.pages.actiontypes.SET_BRANDING;
const setBrandingAction = branding => ({
  type: SET_BRANDING,
  payload: {
    branding
  }
});
svs.tickets_giftshop.pages.actions = {
  setBrandingAction
};

 })(window);